<template>
  <modal :value="show" :small="true" :backdrop="false">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">
        <center v-if="title">{{ title }}</center>
        <center v-else>Loading...</center>
      </h4>
    </div>
    <div slot="modal-body" class="modal-body">
      <div class="progress">
        <div class="progress-bar progress-bar-primary progress-bar-striped active" style="width: 100%;"></div>
      </div>
      <div v-if="content" class="text-center">
        {{ content }}
      </div>
    </div>
    <div slot="modal-footer"></div>
  </modal>
</template>

<script>
import { modal } from 'vue-strap';

export default {
  components: {
    modal,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    content: {
      type: [String, Boolean],
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
  destroyed() {
    // scrolling breaks because the class `modal-open` gets added to the body but is not removed when the modal closes
    // this function fixes scrolling by removing the class manually
    document.body.className = document.body.className.replace('modal-open', '');
  },
};
</script>
